import { donationStatusRules } from '../donationStatusRules'

import { Flex, Text } from '@percent/lemonade'
import styles from './DonationStatusCard.module.scss'
import { Donation } from '@percent/partner-dashboard/services/donation/donationService.types'
import { getDisplayDonationStatus } from '@percent/partner-dashboard/common/library/utility/getDisplayDonationStatus'

export function DonationStatusCard({ donation }: { donation: Donation }) {
  const updatedDonationStatus = getDisplayDonationStatus(donation)

  const status = donationStatusRules.find(
    ({ match }) =>
      (!match.type || match.type.includes(donation.type)) &&
      (!match.status || match.status.includes(updatedDonationStatus))
  )

  if (!status?.show) return null

  return (
    <Flex direction="row" justify="space-between" className={styles.donationStatusCard}>
      {status.currentDescription && <Text size="small">{status.currentDescription}</Text>}
    </Flex>
  )
}
